// extracted by mini-css-extract-plugin
export default {"additionalInformation":"additionalInformation---fthC4"};